module.exports = __webpack_public_path__ + "static/media/discounts-percentage-label-on-calendar-daily-page-svgrepo-com.c768dc62.svg";